// @ts-nocheck
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useAnchor from "@toolkit/Framework/Common/Hooks/useAnchor";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import textToSafeId from "@toolkit/Framework/Common/Utilities/textToSafeId";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useMemo } from "react";

/* Store Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { css } from "styled-components";
/* Store Custom Code - End */

interface OwnProps extends ExpandStyles<AnchorHeadingStyles> {
    title: string;
    anchor: string;
    label?: string;
    forwardAs?: TypographyPresentationProps["forwardAs"];
    variant?: TypographyPresentationProps["variant"];
    // Store Custom Code
    type: string;
    direction: string;
    offset: string;
}

type Props = OwnProps;

export interface AnchorHeadingStyles {
    title?: TypographyPresentationProps;
}

export const AnchorHeadingStyles: AnchorHeadingStyles = {
    title: {
        variant: "h2",
        css: spacingStyles(),
    },
};

const AnchorHeading: FC<Props> = ({
    title,
    anchor,
    label,
    variant,
    forwardAs,
    extendedStyles,
    overridedStyles,
    // Store Custom Code
    type,
    direction,
    offset,
}) => {
    const { isInShell } = useShellContext(); // Store Custom Code
    const styles = useExpandProps(AnchorHeadingStyles, extendedStyles, overridedStyles);
    const safeAnchor = useMemo(() => textToSafeId(anchor), [anchor]);
    const titleStyle: TypographyPresentationProps = useMemo(
        () => ({
            ...styles.title,
            forwardAs: forwardAs || styles.title?.forwardAs,
            variant: variant || styles.title?.variant,
        }),
        [forwardAs, variant, extendedStyles, overridedStyles],
    );

    /* Store Custom Code - Start */
    const invisibleStyles = css`
        width: 100%;
        height: 0;
        position: relative;
        top: ${direction === "top" && "-"}${offset}px;
        ${isInShell &&
        `
			text-align: center;
			color: red;
			background: rgba(255,255,255,0.5);
			height: auto;
			border: 1px dashed red;
			padding: 3px;
			`}
    `;
    /* Store Custom Code - Start */

    useAnchor(safeAnchor, label || title);

    /* Store Custom Code - Start */
    if (type === "invisible") {
        return (
            <StyledWrapper css={invisibleStyles} id={safeAnchor}>
                {isInShell && anchor}
            </StyledWrapper>
        );
    }
    /* Store Custom Code - Start */

    return (
        <Typography id={safeAnchor} {...titleStyle}>
            {title}
        </Typography>
    );
};

export default AnchorHeading;
